import React, { Component } from 'react'
import { StyleSheet, css } from 'aphrodite';
import TermosDeUso from "../Componente/TermosDeUso/TermosDeUso";

class Footer extends Component {

	constructor(props) {
		super(props);

		this.feedback = React.createRef();

		this.state = {
			modalTermosDeUso: (localStorage.getItem("TermoUso") === "true") ? false : true,
			modalFromFooter: false
		}
	}

	modalToggle = () => {
		if (localStorage.getItem("TermoUso") === "true")
			this.setState({ modalFromFooter: !this.state.modalFromFooter })
		else
			this.setState({ modalTermosDeUso: true });
	}

	toggleModalTermosDeUso = () => {
		this.setState({ modalTermosDeUso: !this.state.modalTermosDeUso });
	};

	render() {
		return (
			<div>
				<TermosDeUso modalOpen={this.state.modalTermosDeUso} toggleModal={this.toggleModalTermosDeUso} abrirDoFooter={this.state.modalFromFooter} action={this.modalToggle} />
				<footer>
					<p>
                        Copyright {new Date().getFullYear()} &reg; - Todos os direitos reservados à Econet Editora Empresarial -
						<a className="termosUso" onClick={this.modalToggle}>Termos de Uso</a>
					</p>
				</footer>
			</div>
		)
	}
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Layout/Footer.jsx